import { VisibilityOff, Visibility } from '@mui/icons-material';
import {
  TextField,
  InputAdornment,
  IconButton,
  FormControl,
  Typography,
} from '@mui/material';
import { grey } from '@mui/material/colors';
import { useState } from 'react';

interface PasswordFieldProps {
  label: string;
  confirmLabel?: string;
  placeholder?: string;
  confirmPlaceholder?: string;
  value: string;
  confirmValue?: string;
  onPasswordChange: (value: string) => void;
  onConfirmChange?: (value: string) => void;
  required?: boolean;
  variant?: 'standard' | 'filled' | 'outlined';
  withConfirmation?: boolean;
}
function PasswordField({
  label,
  confirmLabel = 'Confirm Password',
  placeholder,
  confirmPlaceholder = 'Re-enter your password',
  value,
  confirmValue = '',
  onPasswordChange,
  onConfirmChange,
  required = true,
  variant = 'outlined',
  withConfirmation = false,
}: PasswordFieldProps) {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleTogglePassword = () =>
    setShowPassword((showPassword) => !showPassword);
  const handleToggleConfirmPassword = () =>
    setShowConfirmPassword((showConfirmPassword) => !showConfirmPassword);

  return (
    <>
      <FormControl fullWidth>
        <TextField
          label={label}
          placeholder={placeholder ?? 'Enter your password'}
          type={showPassword ? 'text' : 'password'}
          value={value}
          onChange={(e) => onPasswordChange(e.target.value)}
          required={required}
          variant={variant ?? 'outlined'}
          autoComplete="current-password"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={handleTogglePassword} edge="end">
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </FormControl>

      {withConfirmation && (
        <>
          <br />
          <br />
          <FormControl fullWidth>
            <TextField
              label={confirmLabel}
              placeholder={confirmPlaceholder}
              type={showConfirmPassword ? 'text' : 'password'}
              value={confirmValue}
              onChange={(e) => onConfirmChange?.(e.target.value)}
              required={required}
              variant={variant ?? 'outlined'}
              autoComplete="current-password"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleToggleConfirmPassword}
                      edge="end"
                    >
                      {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>
        </>
      )}
    </>
  );
}
export default PasswordField;
